// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-terms {
  background-color: #fffbe7; /* 柔らかい黄色の背景色 */
  border: 0.1rem solid #ff9b15; /* キャンペーンカラーのボーダー */
  border-radius: 0.5rem; /* 角を少し丸める */
  padding: 1.5rem;
  margin: 1.5rem 0;
}

.campaign-terms .title {
  color: #ff7515; /* キャンペーンタイトルの色 */
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.campaign-terms ul {
  list-style-type: disc;
  margin-left: 1.5rem;
}

.campaign-terms li {
  margin-bottom: 0.75rem;
  color: #333;
  font-size: 1rem;
  line-height: 1.5;
}

.campaign-terms li br {
  margin-bottom: 0.5rem;
}

@media (max-width: 767px) {
  .campaign-terms {
    padding: 1rem;
  }

  .campaign-terms .title {
    font-size: 1.2rem;
    color: #ff7515;
  }

  .campaign-terms ul {
    margin-left: 0.1rem;
    padding: 0.5rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/CampaignTerms.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE,eAAe;EAC1C,4BAA4B,EAAE,mBAAmB;EACjD,qBAAqB,EAAE,YAAY;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,iBAAiB;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":[".campaign-terms {\n  background-color: #fffbe7; /* 柔らかい黄色の背景色 */\n  border: 0.1rem solid #ff9b15; /* キャンペーンカラーのボーダー */\n  border-radius: 0.5rem; /* 角を少し丸める */\n  padding: 1.5rem;\n  margin: 1.5rem 0;\n}\n\n.campaign-terms .title {\n  color: #ff7515; /* キャンペーンタイトルの色 */\n  font-size: 1.4rem;\n  font-weight: bold;\n  margin-bottom: 1rem;\n}\n\n.campaign-terms ul {\n  list-style-type: disc;\n  margin-left: 1.5rem;\n}\n\n.campaign-terms li {\n  margin-bottom: 0.75rem;\n  color: #333;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.campaign-terms li br {\n  margin-bottom: 0.5rem;\n}\n\n@media (max-width: 767px) {\n  .campaign-terms {\n    padding: 1rem;\n  }\n\n  .campaign-terms .title {\n    font-size: 1.2rem;\n    color: #ff7515;\n  }\n\n  .campaign-terms ul {\n    margin-left: 0.1rem;\n    padding: 0.5rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
